<template>
  <div>
    <!-- <Popup v-if="openPop"  v-on:close="openPop=false"/> -->
    <label-tag :tagArray="['學習點', '任務']"/>
    <div v-if="this.userInfo" class="recordInfo" style="weight:100%;">
      <h3 class="p-0 mb-3">
        {{this.userInfo.realName}}
      </h3>
      <p class="p-0 ml-3">
        目前累積學習時間: {{this.userInfo.spendTime}}
      </p>
      <p class="p-0 ml-3">
        目前累積總星星數: {{this.userInfo.starCount}}
      </p>
    </div>
    <div class="px-5 table-responsive" style="overflow: auto; min-height:50vh;font-size:1.25rem">
      <table class="table table-borderless table-hover">
        <thead>
          <tr>
            <th class="order-btn pointer">
              區域
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th>中文名稱</th>
            <th class="order-btn pointer">
              星星數
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th class="order-btn pointer">
              {{$t('study_time')}}
              <font-awesome-icon class="form_icon" :icon="['fas', 'sort-down']" />
            </th>
            <th>
              課程進度
            </th>
          </tr>
        </thead>
        <tbody style="border-top:1px #cccccc solid;text-align: left;">
          <tr v-for="(item , index) in record.data" :key="index">
            <td>
              {{item.cityArea}}
            </td>
            <td>
              {{item.name}}
            </td>
            <td>
              {{item.starCount}}
            </td>
            <td>
              {{item.spendTime}}
            </td>
            <td >
              <a @click="goInfo(item.learningPointId)" href="javascript:void(0);">
                {{$t('view')}}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-5" :current="record.pageIndex" :total="record.pageCount" v-on:page="updatePage"/>
  </div>
</template>

<script>
import Pagination from '../../../../components/Pagination'
import api from '../../../../store/api'
import labelTag from '../../tw/record/Label'
export default {
  name: 'TWRecordPersonal',

  data () {
    return {
      userInfo: null,
      openPop: false,
      record: {},
      allStars: 0
    }
  },
  components: {
    labelTag,
    // Popup,
    Pagination
  },
  computed: {
    studentId () {
      return this.$route.params.student
    },
    groupId () {
      return this.$route.params.class
    },
    userAuth () {
      return this.$store.state.auth
    }
  },
  mounted () {
    this.getRecordData()
    this.getStudentInfo()
  },
  methods: {
    async getRecordData () {
      const { data } = await api.get(`/TravelTaiwan/Record/LearningPoint/App/Summary`, {
        params: {
          learninigPointId: this.$route.params.point,
          userId: this.studentId,
          pageIndex: this.record.pageIndex,
          pageSize: 10
        }
      })
      this.record = data
    },
    updatePage (page) {
      this.record.pageIndex = page
      this.getRecordData()
    },
    goInfo (id) {
      this.$router.push({name: 'Record.info.tw', params: {point: id}})
    },
    async getStudentInfo () {
      const { data } = await api.get(`/TravelTaiwan/Record/Student/App/Summary`, {params: {userId: this.studentId}})
      this.userInfo = data.data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/style/color.scss";
  .list-box {
    width: 60%;
    margin: auto;
  }
  .menu-box {
    cursor: pointer;
    text-align: left;
    background-color: #fff;
    border-radius: 10px;
    border: 1.5px solid #6666;
    margin: 10px auto;
    padding: 10px 20px;
    p {
      margin: 0;
    }
      &:hover {
      box-shadow:0px 0px 8px #a1a1a1;
    }
  }
  .order-btn {
    color: rgb(1, 1, 187);
  }
  .recordInfo {
    text-align: left;
    border-bottom: 1px #a1a1a1 solid;
    padding: 50px 10%;
    min-height: 20vh;
    p {
      font-size: 1.5rem;
    }
    h3 {
      font-weight: bold;
    }
  }
</style>


// WEBPACK FOOTER //
// RecordPersonal.vue?c573ed16